module.exports = __webpack_public_path__ + "static/media/uni.f3751193.jpg";